export const LOGIN_DETAIL = 'LOGIN_DETAIL';
